import React from "react";
import PageMeta from "../components/PageMeta";

export default function Legal() {
    return (
        <div className="bg-[#09090b] text-zinc-100">
            <PageMeta
                title="Mentions légales — Sponsormania.fr"
                description="Mentions légales du site Sponsormania.fr : éditeur, hébergeur, propriété intellectuelle, responsabilité."
            />
            <article className="max-w-3xl mx-auto px-6 py-16 space-y-8">
                <div>
                    <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">Infos légales</div>
                    <h1 className="font-display text-5xl uppercase tracking-tight">Mentions légales</h1>
                </div>

                <Section title="Éditeur du site">
                    <p>
                        <strong>Sponsormania.fr</strong> — Plateforme de micro-sponsoring sportif.
                    </p>
                    <p>Siège social : 4, Rue de la République, 69001 Lyon</p>
                    <p>SIRET : 909 837 122 00011</p>
                    <p>N° TVA intracommunautaire : TVA FR54909837122</p>
                    <p>Directeur de la publication : Cédric MIRALLES</p>
                    <p>
                        Contact :{" "}
                        <a className="text-orange-500" href="mailto:contact@sponsormania.fr">contact@sponsormania.fr</a>
                    </p>
                </Section>

                <Section title="Hébergement">
                    <p>
                        Le site est hébergé par Emergent Labs. Tout signalement technique peut être adressé à
                        l'éditeur via l'adresse ci-dessus.
                    </p>
                </Section>

                <Section title="Propriété intellectuelle">
                    <p>
                        L'ensemble des éléments (textes, images, graphismes, logo, marques) présents sur le site
                        sont la propriété exclusive de Sponsormania.fr, sauf mention contraire. Toute reproduction,
                        représentation, modification, publication, adaptation de tout ou partie des éléments du site
                        est strictement interdite sans l'autorisation écrite préalable de Sponsormania.fr.
                    </p>
                </Section>

                <Section title="Responsabilité">
                    <p>
                        Sponsormania.fr met tout en œuvre pour offrir une information fiable et à jour. Cependant, Sponsormania.fr ne
                        saurait être tenu responsable des erreurs ou omissions ni des interruptions de service.
                    </p>
                </Section>

                <Section title="Liens hypertextes">
                    <p>
                        Le site peut proposer des liens vers d'autres sites, dont Sponsormania.fr ne contrôle pas le contenu.
                        Sponsormania.fr décline toute responsabilité quant aux contenus hébergés sur ces sites tiers.
                    </p>
                </Section>

                <p className="text-xs text-zinc-500 pt-6 border-t border-zinc-800">
                    Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}.
                </p>
            </article>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-display text-2xl uppercase tracking-tight text-orange-500 mb-3">{title}</h2>
            <div className="space-y-2 text-zinc-300 leading-relaxed">{children}</div>
        </section>
    );
}
